import { render, staticRenderFns } from "./ManualOrders.vue?vue&type=template&id=4a1a1dac"
import script from "./ManualOrders.vue?vue&type=script&lang=js"
export * from "./ManualOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports